import { IPermission } from "../../types/Auth/role";

export const userPermissionValue: IPermission[] = [
  {
    variableName: "user_account",
    name: "บัญชีผู้ใช้งาน",
    view: "close",
    isCreatable: true,
    create: false,
    isUpdatable: true,
    update: false,
    cancel: false,
    isDeletable: true,
    isLockDelete: true,
    delete: false,
  },
  {
    variableName: "role",
    name: "กำหนดสิทธิ์",
    view: "close",
    isCreatable: true,
    create: false,
    isUpdatable: true,
    update: false,
    cancel: false,
    isDeletable: true,
    isLockDelete: true,
    delete: false,
  },
  {
    variableName: "user_export",
    name: "นำออกข้อมูล",
    view: "close",
    create: false,
    update: false,
    cancel: false,
    delete: false,
  },
];
